import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import useEmployeeViewDataQuery, { QUERY_KEY } from '@/modules/user/queries/useEmployeeViewData.query';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

import { EmployeePayload } from '../user.types';

interface UpdateEmployeePayload {
  is_electronic_statement_only: boolean;
  employee_provided_email: string | null;
  is_employee_email_preferred: boolean;
  citizenship_country_id: number;
  is_sms_notification_enabled: boolean;
}

const useUpdateEmployeeQuery = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (data: Partial<UpdateEmployeePayload>) =>
      api.patch(API_URL.UI_EMPLOYEES, {
        ...data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  return {
    updateEmployee: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};

export const usePutEmployeeQuery = () => {
  const { employee } = useEmployeeStore();
  const { rawData } = useEmployeeViewDataQuery(employee?.id);
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (data: Partial<EmployeePayload>) =>
      api.put(API_URL.UI_EMPLOYEES_BY_EMPLOYEE_ID(employee?.id || ''), {
        ...rawData,
        ...data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  return {
    updateEmployee: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useUpdateEmployeeQuery;
